export enum StockLocationsRoles {
  VIEWER = 'roles.stockLocationsViewer',
  PERSISTER = 'roles.stockLocationsPersister',
  ARCHIVER = 'roles.stockLocationsArchiver',
}
